import * as React from 'react';
import * as Iconify from '@iconify/react';

Iconify.addIcon('antimatterhq:filter', {
  body: '<path fill="currentColor" d="M2.875 5.4H9.125V6.6H2.875V5.4ZM1 3H11V4.2H1V3ZM4.75 7.8H7.25V9H4.75V7.8Z" />',
  width: 12,
  height: 12,
});

Iconify.addIcon('antimatterhq:sort-ascending', {
  body: '<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M10.8535 4.85601L10.1464 5.56302L9 4.41655V10H7.99999V4.41648L6.85348 5.56302L6.14646 4.85598L8.50001 2.5L10.8535 4.85601ZM4.00001 4H1.5V5.00001H4.00001V4ZM4.99999 6.50001H1.5V7.49999H4.99999V6.50001ZM1.5 10H6V8.99999H1.5V10Z" />',
  width: 12,
  height: 12,
});

Iconify.addIcon('antimatterhq:sort-descending', {
  body: '<path fill="currentColor" fill-rule="evenodd" clip-rule="evenodd" d="M1.5 7.49999H4.00001V8.5H1.5V7.49999ZM1.5 5.99999H4.99999V5.00001H1.5V5.99999ZM1.5 3.50001H6V2.5H1.5V3.50001ZM10.1465 6.93716L9 8.08366V2.5H7.99999V8.08366L6.85352 6.93716L6.14648 7.6442L8.50001 10L10.8535 7.6442L10.1465 6.93716Z" />',
  width: 12,
  height: 12,
});

Iconify.addIcon('antimatterhq:binoculars', {
  body: '<path fill="currentColor" d="M15.5725 8.78469L15.5332 8.70614C15.4743 8.55952 15.3957 8.42206 15.3368 8.32388L12.7095 3.44223C12.3468 2.77589 11.6412 2.36353 10.8767 2.36353C9.71947 2.36353 8.77822 3.2943 8.77822 4.44238V5.68734H7.21908V4.44238C7.21908 3.29561 6.27783 2.36353 5.12058 2.36353C4.35606 2.36353 3.65046 2.77589 3.27736 3.45139L0.691878 8.29377C0.604168 8.42075 0.525622 8.55821 0.456239 8.7153C0.259873 9.16564 0.152527 9.64608 0.152527 10.137C0.152527 12.0679 1.74047 13.6362 3.68187 13.6362C5.62328 13.6362 7.22039 12.0679 7.22039 10.137V8.89203H8.77953V10.137C8.77953 12.0679 10.3675 13.6362 12.318 13.6362C14.2686 13.6362 15.8474 12.0679 15.8474 10.137C15.8474 9.66702 15.7597 9.21538 15.5725 8.78469ZM3.68187 12.3337H3.59416C2.40812 12.2852 1.46687 11.3139 1.46687 10.1383C1.46687 9.83459 1.52578 9.53088 1.65276 9.2468C1.7012 9.14862 1.75094 9.06091 1.80985 8.97189C2.16331 8.4129 2.74063 8.04111 3.3978 7.96257C3.49598 7.94293 3.59416 7.94293 3.68187 7.94293C4.9072 7.94293 5.90735 8.92345 5.90735 10.1383C5.90735 11.3532 4.9072 12.3337 3.68187 12.3337ZM5.90735 7.41274C5.82881 7.35383 5.75026 7.29492 5.63244 7.21638C5.55389 7.16794 5.47535 7.1182 5.35753 7.05929C5.26982 7.01085 5.1808 6.9611 5.02371 6.90219C4.936 6.86292 4.83781 6.82365 4.70952 6.78437C4.62181 6.76474 4.52363 6.73594 4.3757 6.70583C4.27752 6.68619 4.17933 6.66655 4.01308 6.64692C3.90573 6.63775 3.79708 6.63775 3.67926 6.63775H3.48289L3.38471 6.64692L3.25772 6.65608L3.02209 6.69535L4.4333 4.06798C4.57076 3.82318 4.8352 3.66609 5.11927 3.66609C5.54997 3.66609 5.90343 4.00907 5.90343 4.44108V7.41144L5.90735 7.41274ZM8.77953 7.58816H7.22039V6.9899H8.77953V7.58816ZM10.0926 4.44238C10.0926 4.01169 10.446 3.66739 10.8767 3.66739C11.1608 3.66739 11.4252 3.81401 11.5535 4.04965L12.9752 6.70583L12.534 6.64692C12.3573 6.62728 12.1413 6.63775 12.0248 6.65608H11.9266C11.8284 6.66525 11.7211 6.68488 11.564 6.71499C11.4763 6.74379 11.3781 6.76343 11.2603 6.79354C11.1621 6.82234 11.0639 6.86161 10.9068 6.93099C10.8191 6.97027 10.7301 7.00954 10.6031 7.07761C10.5246 7.11689 10.446 7.16532 10.3282 7.24387C10.2601 7.29231 10.1907 7.34205 10.0926 7.4206V4.44238ZM12.318 12.3337H12.2303C11.0443 12.2944 10.0939 11.3244 10.0939 10.1383C10.0939 8.95225 11.094 7.94293 12.3194 7.94293C12.4175 7.94293 12.5157 7.9521 12.6034 7.96257C13.2698 8.04111 13.8484 8.4129 14.2018 8.98236C14.2608 9.06091 14.3 9.14862 14.3485 9.23764C14.4754 9.52171 14.5344 9.82543 14.5344 10.1396C14.5344 11.3453 13.5447 12.335 12.3194 12.335L12.318 12.3337Z" />',
  width: 16,
  height: 16,
});

Iconify.addIcon('antimatterhq:sun', {
  body: `
  <path d="M10.8 1.2C10.8 0.537305 11.3373 0 12 0C12.6627 0 13.2 0.537305 13.2 1.2V2.4C13.2 3.0627 12.6627 3.6 12 3.6C11.3373 3.6 10.8 3.0627 10.8 2.4V1.2Z" fill="currentColor"/>
  <path d="M18 12C18 15.3138 15.3138 18 12 18C8.68623 18 6 15.3138 6 12C6 8.68623 8.68623 6 12 6C15.3138 6 18 8.68623 18 12Z" fill="currentColor"/>
  <path d="M12 20.4C11.3373 20.4 10.8 20.9373 10.8 21.6V22.8C10.8 23.4627 11.3373 24 12 24C12.6627 24 13.2 23.4627 13.2 22.8V21.6C13.2 20.9373 12.6627 20.4 12 20.4Z" fill="currentColor"/>
  <path d="M3.51475 5.21177C3.046 4.74302 3.046 3.98335 3.51475 3.5146C3.98335 3.046 4.74316 3.046 5.21177 3.5146L6.06021 4.36318C6.52896 4.83179 6.52896 5.5916 6.06021 6.06021C5.5916 6.52881 4.83179 6.52881 4.36318 6.06021L3.51475 5.21177Z" fill="currentColor"/>
  <path d="M17.9396 17.9396C17.471 18.4083 17.471 19.1681 17.9396 19.6367L18.7882 20.4853C19.2568 20.9539 20.0167 20.9539 20.4853 20.4853C20.9539 20.0167 20.9539 19.2568 20.4853 18.7882L19.6367 17.9396C19.1681 17.471 18.4083 17.471 17.9396 17.9396Z" fill="currentColor"/>
  <path d="M1.2 13.2C0.537305 13.2 0 12.6627 0 12C0 11.3373 0.537305 10.8 1.2 10.8H2.4C3.0627 10.8 3.6 11.3373 3.6 12C3.6 12.6627 3.0627 13.2 2.4 13.2H1.2Z" fill="currentColor"/>
  <path d="M20.4 12C20.4 12.6627 20.9373 13.2 21.6 13.2H22.8C23.4627 13.2 24 12.6627 24 12C24 11.3373 23.4627 10.8 22.8 10.8H21.6C20.9373 10.8 20.4 11.3373 20.4 12Z" fill="currentColor"/>
  <path d="M4.49795 19.8612C3.99038 20.2872 3.23335 20.221 2.80737 19.7134C2.3814 19.2057 2.44761 18.4488 2.95532 18.0227L3.87451 17.2515C4.38223 16.8255 5.13911 16.8917 5.56523 17.3993C5.99121 17.907 5.925 18.6639 5.41729 19.09L4.49795 19.8612Z" fill="currentColor"/>
  <path d="M18.4348 6.60044C18.8607 7.10815 19.6176 7.17437 20.1253 6.74839L21.0445 5.977C21.5522 5.55103 21.6185 4.79414 21.1925 4.28643C20.7665 3.77871 20.0096 3.7125 19.5019 4.13862L18.5826 4.90986C18.075 5.33584 18.0088 6.09287 18.4348 6.60044Z" fill="currentColor"/>
`,
  width: 24,
  height: 24,
});

Iconify.addIcon('antimatterhq:moon', {
  body: '<path d="M12.5694 12.5694C14.8475 10.2914 14.8475 6.59788 12.5694 4.31984C12.3355 4.08591 12.4837 3.65544 12.8129 3.6883C14.6602 3.87273 16.4576 4.67249 17.8727 6.08761C21.1271 9.34197 21.1271 14.6184 17.8727 17.8727C14.6184 21.1271 9.34197 21.1271 6.08761 17.8727C4.67249 16.4576 3.87273 14.6601 3.6883 12.8129C3.65544 12.4837 4.08591 12.3355 4.31984 12.5694C6.59788 14.8475 10.2914 14.8475 12.5694 12.5694Z" fill="currentColor"/>',
  width: 24,
  height: 24,
});

Iconify.addIcon('antimatterhq:trash', {
  body: '<path fill-rule="evenodd" clip-rule="evenodd" d="M8.90112 1.15161H14.9621L16.5979 5.04275H20.8147V7.01954H19.3726L18.0729 22.5627H6.09944L4.52892 7.01954H3.18555V5.04275H7.20685L8.90112 1.15161ZM9.3629 5.04275H14.4536L13.6488 3.1284H10.1964L9.3629 5.04275ZM6.51577 7.01954L7.88655 20.5859H16.2545L17.3889 7.01954H6.51577Z" fill="currentColor"/>',
  width: 24,
  height: 24,
});

Iconify.addIcon('antimatterhq:pencil', {
  body: '<path d="M15 5L19 9M21.1739 6.81189C21.7026 6.28332 21.9997 5.56636 21.9998 4.81875C21.9999 4.07113 21.703 3.3541 21.1744 2.82539C20.6459 2.29668 19.9289 1.99961 19.1813 1.99951C18.4337 1.99942 17.7166 2.29632 17.1879 2.82489L3.84193 16.1739C3.60975 16.4054 3.43805 16.6904 3.34193 17.0039L2.02093 21.3559C1.99509 21.4424 1.99314 21.5342 2.01529 21.6217C2.03743 21.7092 2.08285 21.7891 2.14673 21.8529C2.21061 21.9167 2.29055 21.962 2.37809 21.984C2.46563 22.006 2.55749 22.0039 2.64393 21.9779L6.99693 20.6579C7.3101 20.5626 7.59511 20.392 7.82693 20.1609L21.1739 6.81189Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  width: 24,
  height: 24,
});

Iconify.addIcon('antimatterhq:columns', {
  body: '<path d="M9 3V21M15 3V21M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3Z" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>',
  width: 24,
  height: 24,
});

Iconify.addIcon('antimatterhq:custom-datasource', {
  body: `
      <path
        d="M54.4375 27.875C64.3441 27.875 72.375 24.4332 72.375 20.1875C72.375 15.9418 64.3441 12.5 54.4375 12.5C44.5309 12.5 36.5 15.9418 36.5 20.1875C36.5 24.4332 44.5309 27.875 54.4375 27.875Z"
        stroke="currentColor" fill="none" stroke-width="3.075" />
    <path
        d="M36.5 35.5625V45.8125C36.5 50.0586 44.5309 53.5 54.4375 53.5C64.3441 53.5 72.375 50.0586 72.375 45.8125V35.5625"
        stroke="currentColor" fill="none" stroke-width="3.075" stroke-linecap="square" />
    <path
        d="M36.5 20.1875V33C36.5 37.2461 44.5309 40.6875 54.4375 40.6875C64.3441 40.6875 72.375 37.2461 72.375 33V20.1875"
        stroke="currentColor" fill="none" stroke-width="3.075" />
    <mask id="path-6-inside-1_7914_96826" fill="white">
        <rect x="0.51416" y="0.31897" width="25" height="21.2206" rx="2" />
    </mask>
    <rect x="0.51416" y="0.31897" width="25" height="21.2206" rx="2" stroke="currentColor"
        stroke-width="6" mask="url(#path-6-inside-1_7914_96826)" fill="none" />
    <path d="M13.0142 21.5396V38.4072H35.5142" stroke="currentColor" stroke-width="3" fill="none" />
    <path d="M7.40283 8.21823H18.6255" stroke="currentColor" stroke-width="3" stroke-linecap="round"
        fill="none" />
    <path d="M9.2832 14.0686H16.7456" stroke="currentColor" stroke-width="3" stroke-linecap="round"
        fill="none" />
  `,
  width: 74,
  height: 56,
});

export const Icons = [
  // antimatterhq icons
  'antimatterhq:binoculars',
  'antimatterhq:filter',
  'antimatterhq:sort-ascending',
  'antimatterhq:sort-descending',
  'antimatterhq:sun',
  'antimatterhq:moon',
  'antimatterhq:trash',
  'antimatterhq:pencil',
  'antimatterhq:columns',
  'antimatterhq:custom-datasource',
  // other icons
  'clarity:drag-handle-line',
  'fa:undo',
  'heroicons:archive-box-20-solid',
  'heroicons:arrow-down-20-solid',
  'heroicons:arrow-down-tray-20-solid',
  'heroicons:arrow-up-20-solid',
  'heroicons:arrows-up-down-20-solid',
  'heroicons:equals',
  'heroicons:magnifying-glass',
  'heroicons:view-columns',
  'ic:twotone-drag-indicator',
  'icon-park-outline:format-brush',
  'lucide:bolt',
  'lucide:box-select',
  'lucide:calendar',
  'lucide:check-circle',
  'lucide:check',
  'lucide:chevron-left',
  'lucide:chevron-right',
  'lucide:chevron-up',
  'lucide:chevron-down',
  'lucide:chevrons-left',
  'lucide:chevrons-right',
  'lucide:circle',
  'lucide:circle-check',
  'lucide:circle-x',
  'lucide:clipboard-paste',
  'lucide:copy',
  'lucide:database',
  'lucide:ellipsis-vertical',
  'lucide:external-link',
  'lucide:expand',
  'lucide:eye',
  'lucide:folder-open',
  'lucide:grip-vertical',
  'lucide:layout-dashboard',
  'lucide:life-buoy',
  'lucide:list',
  'lucide:loader-circle',
  'lucide:log-out',
  'lucide:message-circle-question',
  'lucide:minus',
  'lucide:notebook',
  'lucide:octagon-alert',
  'lucide:octagon-x',
  'lucide:plus',
  'lucide:search',
  'lucide:shapes',
  'lucide:shield-plus',
  'lucide:square-user',
  'lucide:trending-down',
  'lucide:trending-up',
  'lucide:triangle-alert',
  'lucide:user',
  'lucide:wifi-off',
  'lucide:x',
  'material-symbols-light:filter-list-rounded',
  'mdi:circle',
  'octicon:sort-asc-16',
  'octicon:sort-desc-16',
  'radix-icons:caret-left',
  'radix-icons:caret-right',
  'radix-icons:check',
  'radix-icons:dots-horizontal',
  'radix-icons:drag-handle-dots-2',
  'radix-icons:external-link',
  'radix-icons:plus',
  'radix-icons:reload',
  'radix-icons:update',
  'radix-icons:grid',
  'radix-icons:list-bullet',
] as const;

export type IconType = (typeof Icons)[number];

const IconComponent = React.forwardRef<
  SVGSVGElement,
  Omit<Iconify.IconProps, 'icon'> & { icon: IconType }
>(({ icon, ...props }, ref) => {
  return <Iconify.Icon ref={ref} icon={icon} {...props} />;
});
IconComponent.displayName = 'Icon';

export const Icon = React.memo(IconComponent);
